module.exports = __webpack_public_path__ + "img/nexi_logo.b7bc4743.png";